// extracted by mini-css-extract-plugin
export var partner__imgWrapper = "ourPartners-module--partner__img-wrapper--9e935";
export var partner__name = "ourPartners-module--partner__name--1443a";
export var partners = "ourPartners-module--partners--1aec8";
export var partners__block = "ourPartners-module--partners__block--da4f9";
export var partners__item = "ourPartners-module--partners__item--b511b";
export var partners__title = "ourPartners-module--partners__title--de29e";